import React from 'react';
import FontAwesome from 'react-fontawesome';
import { _DropzoneOverlay } from "../../style";
var DropzoneOverlay = function DropzoneOverlay(_ref) {
  var dragging = _ref.dragging,
    hovering = _ref.hovering,
    full = _ref.full;
  return /*#__PURE__*/React.createElement(_DropzoneOverlay, {
    dragging: dragging,
    hovering: hovering,
    full: full
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: hovering ? 'folder-open' : 'folder'
  }), /*#__PURE__*/React.createElement("span", null, "Drop here to upload file...")));
};
export default DropzoneOverlay;